import { host } from './utils';

const nameRoot = host.replace('https://', '').replaceAll('-', ' ');
const name = `${nameRoot.substring(0, 1).toUpperCase() + nameRoot.substring(1)} Blog - Resources`;

const jsonLdBlog = {
  '@type': 'Blog',
  '@id': `${host}/blog`,
  mainEntityOfPage: `${host}/blog`,
  name,
  description:
    'Our blog covers topics about the 16 personality types, ranging from their strengths and weaknesses to compatibility and beyond.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${host}/search/{search_query}`,
    'query-input': 'required name=search_query',
  },
};

export default jsonLdBlog;
